import React from 'react'
import './SideBar.css'
import {
    Paper,
    Typography,
    Box
} from '@material-ui/core'
import { NavLink,Link } from 'react-router-dom'

export default function SideBar() {
  return (

    <div class ="SideBar">
     <Box className="side-box">
                            <Link to="#" className="Start-link">Start</Link>
                        </Box>
                        <Box className="side-box">
                            <NavLink to="/rec" 
                           
                            className="Rec-info-link"
                            >Recruiting Information</NavLink>
                        </Box>
                        <Box className="side-box">
                            
                            <NavLink to="/JobInfo"

                             className="Job-info-link"
                             >Job
                            </NavLink>
                        </Box>
                        <Box className="side-box">
                            <NavLink to="/org" className="Org-link">Organisations</NavLink>
                        </Box>
                        
                        <Box className="side-box">
                            <NavLink to="/att" className="Att-link">Attachments</NavLink>
                        </Box>
                        <Box className="side-box">
                            <NavLink to="/compensation" className="Comp-link">compensation</NavLink>
                        </Box>
                        <Box className="side-box">
                            <NavLink to="/assignedroles" className="Ass-role-link">Assigned Roles</NavLink>
                        </Box>
                        <Box className="side-box">
                            <NavLink to="/summary" className="summ-link">Summary</NavLink>
                        </Box>

    </div>
  )
}

